var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.loading)?[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.shouldRenderApplication)?_c('Application',[_c('router-view')],1):_c('router-view')],1)]:[_c('div',{staticClass:"fill-height d-flex align-center justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}})],1)],_c('SnackBar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }